import BaseModel from "@/Store/BaseModel";
export default class SampleFlagType extends BaseModel {
	static entity = 'sampleFlagTypes';
	static primaryKey = "uuid";
	
	static fields() {
		return {
			uuid: this.attr(null),
			name: this.attr(null),
			description: this.attr(null),
			color: this.attr(null),
			display_index: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
		}
	}
	static beforeSelect(types){
		return types.sort((a,b) => {
			return a.display_index - b.display_index
		})
	}
	static ignoredLogFields(){
		return ['created_at', 'updated_at']
	}
	
	static name(){
		return "SampleFlagType"
	}
	
	static route(){
		return process.env.VUE_APP_RECORDED_API + '/sampleFlagTypes';
	}
	
	static apiConfig = {
		...super.apiConfig,
		headers: {
			"Accept": "application/json",
			"Authorization": process.env.VUE_APP_RECORDED_API_KEY,
			"VueRoute": window.location.href,
		}
	}
}
